import * as React from 'react';

interface IProps {
	className?: string;
}

export const ExclamationIcon: React.FC<IProps> = ({ className }) => {
	return (
		<svg
			className={className}
			viewBox='0 0 24 24'
			fill='none'
			stroke='currentColor'
			strokeWidth='2'
			strokeLinecap='round'
			strokeLinejoin='round'
		>
			<circle cx='12' cy='12' r='11' />
			<path d='M12 8v4' />
			<path d='m12 16 .01 0' />
		</svg>
	);
};
